<template>
  <div class="goods">
    <div class="detailsTitle">
      <div class="detailsWrap"></div>
      <p>商品訊息</p>
    </div>

    <el-form>
      <el-form-item label="商品名稱:">
        <input
          maxlength="60"
          placeholder="請輸入商品名稱（60個字符以內）"
          class="el-input__inner"
          type="text"
          v-model="goods.name"
        />
      </el-form-item>

      <el-form-item label="商品編號:">
        <el-input
          :disabled="type === 'edit' && goods.status === '售賣中'"
          v-model="goods.goodsNo"
          type="text"
          placeholder="請輸入玉山銀行後臺商品編號"
        />
      </el-form-item>
      <el-form-item label="商品類型:" v-if="type === 'edit'">
        <p class="blackColor" v-if="goods.goodsType == 0">一般商品</p>
        <p class="blackColor" v-if="goods.goodsType == 1">義賣商品</p>
        <p class="blackColor" v-if="goods.goodsType == 2">年度會服商品</p>
        <!-- <p class="blackColor" v-if="goods.type == 2">僅限最新年度VIP用戶</p>
        <p class="blackColor" v-if="goods.type == 3">指定VIP用戶可見</p> -->
      </el-form-item>
      <el-form-item label="商品類型:" v-else>
        <el-radio-group v-model="goods.goodsType" @input="handchange">
          <el-radio :label="0">一般商品</el-radio>
          <el-radio :label="1">義賣商品</el-radio>
          <el-radio :label="2">年度會服商品</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="用户類型:" v-if="goods.goodsType == 2">
        <el-radio-group
          v-model="goods.goodsUserType"
          @input="handchange"
          :disabled="true"
        >
          <el-radio :label="0">所有用戶</el-radio>
          <el-radio :label="1">VIP用戶</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="用户類型:" v-else>
        <el-radio-group
          v-model="goods.goodsUserType"
          @input="handchange"
          :disabled="
            type == 'edit' && goods.status != '即將售賣' && goods.goodsType == 1
          "
        >
          <el-radio :label="0">所有用戶</el-radio>
          <el-radio :label="1">VIP用戶</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="type === 'edit' && goods.status === '售賣中'"
        label="限購數量:"
      >
        <el-input disabled v-model="goods.limited" type="text" />
      </el-form-item>

      <el-form-item v-else label="限購數量:">
        <el-input-number
          v-model="goods.limited"
          :controls="false"
          :min="1"
          :max="99"
        >
        </el-input-number>
      </el-form-item>

      <el-form-item label="商品運費:" v-if="type === 'add' || type === 'draft'">
        <el-radio-group v-model="goods.freight" @change="changeYunfei">
          <el-radio :label="'0'">免運費</el-radio>
          <el-radio :label="'1'">郵費</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="商品運費:" v-if="type === 'edit'">
        <p class="blackColor" v-if="goods.freight == 0">免運費</p>
        <p class="blackColor" v-if="goods.freight == 1">運費</p>
      </el-form-item>
      <el-form-item
        label="上傳運費模板:"
        v-if="
          goods.freight == 1 && (type === 'add' || goods.status === '即將售賣')
        "
      >
        <el-select
          v-model="goods.freightId"
          @change="changefreight"
          placeholder="選擇運費模板"
        >
          <el-option
            style="max-width: 1000px"
            :label="item.templateTitle"
            :value="item.id"
            v-for="item in yunfeiData"
            :key="item.id"
          >
          </el-option>
          <div style="display: flex; justify-content: flex-end">
            <el-pagination
              small
              layout="prev, pager, next"
              hide-on-single-page
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="5"
              :pager-count="5"
              :total="total"
            >
            </el-pagination>
          </div>
        </el-select>
        <div class="yunfeiBox" @click="showYunfei('modal')">管理運費模板</div>
      </el-form-item>
      <el-form-item
        label="運費模板:"
        v-if="goods.status != '即將售賣' && goods.freight == 1 && type != 'add'"
      >
        <p class="blackColor" style="white-space: normal">
          {{ goods.freightTitle }}
        </p>
      </el-form-item>
      <el-form-item
        label="商品主圖:"
        class="picupload"
        v-show="
          type === 'add' ||
          (type === 'edit' &&
            (goods.status === '即將售賣' || goods.status === '已售完')) ||
          type === 'draft'
        "
      >
        <el-upload
          action=""
          :http-request="uploadRequest"
          :headers="{ Authorization: this.$cookie.get('auth') }"
          :with-credentials="true"
          :data="uploadData"
          :on-remove="handleRemove"
          :on-error="$errorImage"
          :file-list="mainPicUrl"
          :on-exceed="$handleExceed.bind(this, 5)"
          :before-upload="beforePicUpload"
          :limit="5"
          accept=".jpg,.jpeg,.png"
          :multiple="false"
          name="multipartFile"
          list-type="picture-card"
        >
          <el-button size="small" type="primary">選擇圖片</el-button>
          <div slot="tip" class="el-upload__tip">
            需上傳完整500*500的正方形圖標，支持jpg/png格式(2MB以內)
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item
        v-if="
          type === 'edit' &&
          (goods.status === '售賣中' || goods.status === '已售完')
        "
        label="商品規格  ："
        class="specification"
      >
        <div class="specificationItem">
          重量
          <el-input disabled v-model="goods.weight" />
          kg
        </div>
        <div class="specificationItem">
          長度
          <el-input disabled v-model="goods.length" />
          cm
        </div>
        <div class="specificationItem">
          寬度
          <el-input disabled v-model="goods.width" />
          cm
        </div>
        <div class="specificationItem">
          高度
          <el-input disabled v-model="goods.height" />
          cm
        </div>
      </el-form-item>
      <el-form-item v-else label="商品規格:" class="specification">
        <div class="specificationItem">
          重量
          <el-input
            placeholder="請輸入商品規格，僅支持整數數字"
            v-model="goods.weight"
            type="text"
            maxlength="12"
          />
          kg
        </div>
        <div class="specificationItem">
          長度
          <el-input
            placeholder="請輸入商品規格，僅支持整數數字"
            v-model="goods.length"
            type="text"
            maxlength="12"
          />
          cm
        </div>
        <div class="specificationItem">
          寬度
          <el-input
            placeholder="請輸入商品規格，僅支持整數數字"
            v-model="goods.width"
            type="text"
            maxlength="12"
          />
          cm
        </div>
        <div class="specificationItem">
          高度
          <el-input
            placeholder="請輸入商品規格，僅支持整數數字"
            v-model="goods.height"
            type="text"
            maxlength="12"
          />
          cm
        </div>
      </el-form-item>
      <div class="detailsTitle" v-show="type === 'add' || type === 'draft'">
        <div class="detailsWrap"></div>
        <p>限制條件</p>
      </div>
      <el-form-item label="會員購買限制:" v-if="goods.goodsType == 2">
        <el-radio-group
          v-model="goods.type"
          @change="handchangeVip"
          :disabled="true"
        >
          <el-radio :label="1">不限</el-radio>
          <el-radio :label="2">最新年度VIP</el-radio>
          <el-radio :label="3">自定義</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="會員購買限制:"
        v-if="goods.goodsUserType == 1 && goods.goodsType != 2"
      >
        <el-radio-group
          v-model="goods.type"
          @change="handchangeVip"
          :disabled="type == 'edit' && goods.status == '售賣中'"
        >
          <el-radio :label="1">不限</el-radio>
          <el-radio :label="2">最新年度VIP</el-radio>
          <el-radio :label="3">自定義</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="會員截至時間"
        v-if="goods.type == 3 && goods.goodsUserType == 1"
      >
        <el-date-picker
          :disabled="type == 'edit' && goods.status == '售賣中'"
          v-model="goods.vipTime"
          type="datetime"
          placeholder="請選擇日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item
        label="提示文案"
        v-if="goods.type == 3 && goods.goodsUserType == 1"
      >
        <div style="display: flex">
          <div>
            <el-input
              :disabled="type == 'edit' && goods.status == '售賣中'"
              v-model="goods.vipTimeCn"
              type="textarea"
              placeholder="請輸入提示文案"
              :rows="3"
              v-show="languageType == 'cn'"
            />
            <el-input
              v-model="goods.vipTimeTw"
              :disabled="type == 'edit' && goods.status == '售賣中'"
              type="textarea"
              placeholder="請輸入提示文案"
              v-show="languageType == 'tw'"
            />
            <el-input
              v-model="goods.vipTimeEn"
              :disabled="type == 'edit' && goods.status == '售賣中'"
              type="textarea"
              placeholder="請輸入提示文案"
              v-show="languageType == 'en'"
            />
          </div>
          <div
            v-for="(item, indexs) in newslanguageList"
            :key="indexs"
            @click="changeLanguage(item.type)"
            :class="indexs == 1 ? 'lglabel lbnone' : 'lglabel'"
            :style="{
              background: languageType == item.type ? '#6C3DEA' : '',
              color: languageType == item.type ? '#fff' : '#6C3DEA',
              display: 'inline-block',
            }"
          >
            {{ item.label }}
          </div>
        </div>
      </el-form-item>
      <el-form-item label="指定用戶可見">
        <el-switch
          active-color="#6C3DEA"
          v-model="goods.goodsInvisible"
          :disabled="
            (type == 'edit' && goods.status != '即將售賣') || goods.special == 2
          "
        >
        </el-switch>
        <div style="display: flex" v-if="goods.goodsInvisible">
          <button
            class="btn"
            type="button"
            @click="uploadModal"
            :disabled="
              (type == 'edit' && goods.status != '即將售賣') ||
              goods.special == 2
            "
          >
            上傳文件
          </button>
          <div
            style="margin-left: 10px; color: #6c3dea; cursor: pointer"
            @click="downloadExcel"
          >
            下載模板
          </div>
        </div>
      </el-form-item>
      <el-form-item label="地区选择:">
        <el-radio-group
          v-model="goods.mainland"
          :disabled="type == 'edit' && goods.status != '即將售賣'"
        >
          <el-radio :label="0">不限</el-radio>
          <el-radio :label="1">大陆</el-radio>
          <el-radio :label="2">非大陆</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="黑名單限制購買">
        <el-switch
          active-color="#6C3DEA"
          v-model="goods.goodsGardenia"
          :disabled="type == 'edit' && goods.status != '即將售賣'"
        >
        </el-switch>
      </el-form-item>
      <div v-if="goods.goodsType == 1">
        <div class="detailsTitle">
          <div class="detailsWrap"></div>
          <p>義賣商品規則</p>
        </div>
        <el-form-item label="義賣類型:">
          <el-radio-group
            v-model="goods.special"
            :disabled="
              (type == 'edit' && goods.status != '即將售賣') ||
              (goods.goodsType == 1 && goods.goodsUserType == 1)
            "
            @change="changeSpecial"
          >
            <el-radio :label="1">綫上義賣</el-radio>
            <el-radio :label="2">綫下活動義賣</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="關連義賣核銷活動ID" v-if="goods.special == 2">
          <el-input
            v-model="goods.writeOffActivityId"
            placeholder="請輸入核銷活動ID"
            style="width: 150px"
            :disabled="type == 'edit' && goods.status != '即將售賣'"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="幸運號碼設置">
          <el-input
            v-model="goods.numberMinDigit"
            placeholder="請輸入最小數字"
            style="width: 150px"
            :disabled="type == 'edit' && goods.status != '即將售賣'"
            @input="validateMinDigit"
          >
          </el-input>
          ——
          <el-input
            v-model="goods.numberMaxDigit"
            placeholder="請輸入最大數字"
            style="width: 150px"
            :disabled="type == 'edit' && goods.status != '即將售賣'"
            @input="validateMaxDigit"
          >
          </el-input>
        </el-form-item>
      </div>
      <div class="detailsTitle" v-show="type === 'add' || type === 'draft'">
        <div class="detailsWrap"></div>
        <p>商品售賣規則</p>
      </div>
      <el-form-item label="上架時間">
        <el-radio-group
          @change="timingChange"
          v-model="goods.listStatus"
          :disabled="
            // (type === 'edit' && goods.status != '即將售賣') ||
            type === 'edit' && goods.status == '售賣中' && timeType == 1
          "
        >
          <el-radio :label="1">立即上架</el-radio>
          <el-radio :label="0">
            <span> 定時上架 </span>
            <el-date-picker
              v-model="goods.listStartTime"
              type="datetime"
              placeholder="請选择上架时间"
              :picker-options="pickerOptions"
              :disabled="
                (type === 'edit' && goods.status != '即將售賣') ||
                (type === 'edit' && goods.status == '即將售賣' && timeType == 1)
              "
            >
            </el-date-picker
          ></el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="售賣時間"
        v-show="
          type === 'add' ||
          type === 'draft' ||
          (type === 'edit' && goods.status === '即將售賣')
        "
      >
        <el-date-picker
          v-model="goods.shelfTime"
          type="datetime"
          placeholder="請选择商品開售時間"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item
        label="售賣時間"
        v-if="type === 'edit' && goods.status != '即將售賣' && !shelfTime"
      >
        <el-date-picker
          v-model="goods.shelfTime"
          type="datetime"
          placeholder="請选择商品開售時間"
          disabled
        >
        </el-date-picker>
      </el-form-item>
      <!-- <el-form-item
        v-if="
          (type === 'edit' && goods.status != '即將售賣') ||
            (type === 'edit' &&
              goods.status == '即將售賣' &&
              goods.listStatus == 1)
        "
        label="上架時間"
      >
        <el-date-picker
          disabled
          v-model="goods.listStartTime"
          type="datetime"
          placeholder="选择时间"
        >
        </el-date-picker>
      </el-form-item> -->
      <el-form-item v-if="type === 'edit' && shelfTime" label="售賣時間">
        <el-date-picker
          disabled
          v-model="shelfTime"
          type="datetime"
          placeholder="請选择商品開售時間"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="付款時間">
        <el-select
          v-model="goods.payTime"
          placeholder="請選擇付款時間"
          :disabled="
            (goods.status === '售賣中' || goods.status === '已售完') &&
            type == 'edit'
          "
        >
          <el-option label="5分鐘" :value="5"></el-option>
          <el-option label="10分鐘" :value="10"></el-option>
          <el-option label="15分鐘" :value="15"></el-option>
          <el-option label="30分鐘" :value="30"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="是否可退款">
        <el-switch
          active-color="#6C3DEA"
          v-model="goods.refund"
          active-value="1"
          inactive-value="0"
          disabled
        >
        </el-switch>
      </el-form-item> -->
      <el-form-item label="是否支持收貨人信息修改">
        <el-switch
          :disabled="goods.status != '即將售賣' && type == 'edit'"
          style="margin-left: 30px"
          active-color="#6C3DEA"
          v-model="goods.receiver"
          :active-value="1"
          :inactive-value="0"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="是否可換貨">
        <el-switch
          active-color="#6C3DEA"
          v-model="goods.exchange"
          active-value="1"
          inactive-value="0"
          disabled
        >
        </el-switch>
      </el-form-item>
    </el-form>
    <div class="detailsTitle">
      <div class="detailsWrap"></div>
      <p>訂單詳情</p>
    </div>
    <div
      style="display: flex; align-items: center"
      v-if="type === 'add' || goods.status === '即將售賣'"
    >
      <p style="color: #000000; font-size: 14px">提交订单提示：</p>
      <el-select
        style="width: 210px"
        v-model="goods.orderPromptId"
        @change="changeWenan"
        placeholder="非必填，請選擇訂單提示模版"
      >
        <el-option
          style="max-width: 1000px"
          :label="item.title"
          :value="item.id"
          v-for="item in wenanData"
          :key="item.id"
        >
        </el-option>
        <div style="display: flex; justify-content: flex-end">
          <el-pagination
            small
            layout="prev, pager, next"
            hide-on-single-page
            @current-change="handlePageChange"
            :current-page="page"
            :page-size="5"
            :pager-count="5"
            :total="alltotal"
          >
          </el-pagination>
        </div>
      </el-select>
      <div class="yunfeiBox" @click="showWenan('modal')">管理文案模板</div>
    </div>
    <div
      style="display: flex; align-items: center"
      v-if="goods.status != '即將售賣' && type != 'add' && goods.orderPromptId"
    >
      <p style="color: #000000; font-size: 14px">提交订单提示：</p>
      <p class="blackColor" style="white-space: normal; margin-left: 20px">
        {{ goods.orderPromptTitle }}
      </p>
    </div>
    <p style="display: flex; color: #000000; font-size: 14px; margin-top: 15px">
      訂單詳情提示：
    </p>
    <div
      style="margin-left: 30px; margin-top: 20px"
      v-for="(item, index) in promptList"
      :key="index"
    >
      <div class="common_flex">
        <div class="order_title">標題：</div>
        <el-input
          :disabled="type == 'edit' && goods.status != '即將售賣'"
          style="width: 200px"
          type="text"
          placeholder="请输入提示文案"
          v-model="item.titleCn"
          maxlength="200"
          v-if="orderlanguageType[index] == 'cn'"
        />
        <el-input
          v-model="item.titleTw"
          style="width: 200px"
          type="text"
          :disabled="type == 'edit' && goods.status != '即將售賣'"
          placeholder="请输入提示文案"
          maxlength="200"
          v-if="orderlanguageType[index] == 'tw'"
        />
        <el-input
          v-model="item.titleEn"
          style="width: 200px"
          type="text"
          :disabled="type == 'edit' && goods.status != '即將售賣'"
          placeholder="请输入提示文案"
          maxlength="200"
          v-if="orderlanguageType[index] == 'en'"
        />
        <div
          v-for="(items, indexs) in newslanguageList"
          :key="indexs"
          @click="changeLanguageorder(index, items.type)"
          :class="indexs == 1 ? 'lglabel lbnone' : 'lglabel'"
          :style="{
            background: orderlanguageType[index] == items.type ? '#6C3DEA' : '',
            color: orderlanguageType[index] == items.type ? '#fff' : '#6C3DEA',
            display: 'inline-block',
          }"
        >
          {{ items.label }}
        </div>
      </div>
      <div style="margin-top: 10px" class="common_flex">
        <div class="order_title">内容：</div>
        <el-input
          style="width: 200px"
          type="text"
          v-model="item.content"
          :disabled="type == 'edit' && goods.status != '即將售賣'"
          placeholder="請輸入H5鏈接"
        />
        <button
          class="add_de"
          @click="addprompt"
          v-show="index == promptList.length - 1"
          :disabled="type == 'edit' && goods.status != '即將售賣'"
        >
          添加
        </button>
        <button
          class="add_de"
          style="color: red"
          @click="delprompt(index)"
          v-show="index != 0 && index == promptList.length - 1"
          :disabled="type == 'edit' && goods.status != '即將售賣'"
        >
          刪除
        </button>
      </div>
    </div>
    <div
      class="detailsTitle"
      v-show="type === 'add' || type === 'draft'"
      style="margin-top: 20px"
    >
      <div class="detailsWrap"></div>
      <p>商品庫存</p>
    </div>
    <el-form>
      <el-form-item label="會員價" v-show="type === 'add' || type === 'draft'">
        <el-switch
          active-color="#6C3DEA"
          v-model="vipPrice"
          @change="changePrice"
          :disabled="goods.goodsType == 2"
        >
        </el-switch>
      </el-form-item>
    </el-form>
    <el-form v-show="(type === 'add' || type === 'draft') && vipPrice">
      <el-form-item class="goodsAdd" label="SKU:">
        <div class="goodsWrap" v-for="(item, index) in skuList" :key="index">
          <div class="goodsItem">
            <input
              v-model="item.value"
              class="el-input__inner"
              type="text"
              maxlength="50"
            />
          </div>
          <span class="delBtn" @click="delGoodsItem(index, skuList)">删除</span>
        </div>

        <div v-show="skuList.length < 15" class="addDetail" @click="addSku()">
          添加
        </div>

        <table class="skuTable">
          <thead>
            <tr>
              <th v-if="skuList.length !== 0">商品尺寸</th>
              <th>價格(TWD)</th>
              <th>會員價(TWD)</th>
              <th>價格(CNY)</th>
              <th>會員價(CNY)</th>
              <th>總庫存</th>
            </tr>
          </thead>
          <tbody v-if="skuList.length !== 0">
            <tr v-for="(item, index) in skuList" :key="index">
              <td>
                {{ item.value }}
              </td>
              <td>
                <input
                  type="text"
                  name=""
                  v-model="item.realPrice"
                  @change="
                    item.realPrice = item.realPrice
                      .replace(/[^0-9.]/g, '')
                      .replace(/^(\d+(\.\d{1,2})?).*$/, '\$1')
                  "
                />
              </td>
              <td>
                <input
                  type="text"
                  name=""
                  v-model="item.vipRealPrice"
                  @change="
                    item.vipRealPrice = item.vipRealPrice
                      .replace(/[^0-9.]/g, '')
                      .replace(/^(\d+(\.\d{1,2})?).*$/, '\$1')
                  "
                />
              </td>
              <td>
                <input
                  type="text"
                  name=""
                  v-model="item.priceRmb"
                  @change="
                    item.priceRmb = item.priceRmb
                      .replace(/[^0-9.]/g, '')
                      .replace(/^(\d+(\.\d{1,2})?).*$/, '\$1')
                  "
                />
              </td>
              <td>
                <input
                  type="text"
                  name=""
                  v-model="item.vipPriceRmb"
                  @change="
                    item.vipPriceRmb = item.vipPriceRmb
                      .replace(/[^0-9.]/g, '')
                      .replace(/^(\d+(\.\d{1,2})?).*$/, '\$1')
                  "
                />
              </td>
              <td>
                <input
                  type="text"
                  name=""
                  id=""
                  v-model="item.realTotal"
                  @change="
                    item.realTotal = item.realTotal.replace(/^(0+)|[^\d]+/g, '')
                  "
                />
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td>
                <input
                  type="text"
                  name=""
                  v-model="skuRequest.realPrice"
                  @change="
                    skuRequest.realPrice = skuRequest.realPrice
                      .replace(/[^0-9.]/g, '')
                      .replace(/^(\d+(\.\d{1,2})?).*$/, '\$1')
                  "
                />
              </td>
              <td>
                <input
                  type="text"
                  name=""
                  v-model="skuRequest.vipRealPrice"
                  @change="
                    skuRequest.vipRealPrice = skuRequest.vipRealPrice
                      .replace(/[^0-9.]/g, '')
                      .replace(/^(\d+(\.\d{1,2})?).*$/, '\$1')
                  "
                />
              </td>
              <td>
                <input
                  type="text"
                  name=""
                  v-model="skuRequest.priceRmb"
                  @change="
                    skuRequest.priceRmb = skuRequest.priceRmb
                      .replace(/[^0-9.]/g, '')
                      .replace(/^(\d+(\.\d{1,2})?).*$/, '\$1')
                  "
                />
              </td>
              <td>
                <input
                  type="text"
                  name=""
                  v-model="skuRequest.vipPriceRmb"
                  @change="
                    skuRequest.vipPriceRmb = skuRequest.vipPriceRmb
                      .replace(/[^0-9.]/g, '')
                      .replace(/^(\d+(\.\d{1,2})?).*$/, '\$1')
                  "
                />
              </td>
              <td>
                <input
                  type="text"
                  name=""
                  id=""
                  v-model="skuRequest.realTotal"
                  @change="
                    skuRequest.realTotal = skuRequest.realTotal.replace(
                      /^(0+)|[^\d]+/g,
                      ''
                    )
                  "
                />
              </td>
            </tr>
          </tbody>
        </table>
      </el-form-item>
    </el-form>
    <el-form v-show="(type === 'add' || type === 'draft') && !vipPrice">
      <el-form-item class="goodsAdd" label="SKU:">
        <div class="goodsWrap" v-for="(item, index) in skuList" :key="index">
          <div class="goodsItem">
            <input
              v-model="item.value"
              class="el-input__inner"
              type="text"
              maxlength="50"
            />
          </div>
          <span class="delBtn" @click="delGoodsItem(index, skuList)">删除</span>
        </div>

        <div v-show="skuList.length < 15" class="addDetail" @click="addSku()">
          添加
        </div>

        <table class="skuTable">
          <thead>
            <tr>
              <th v-if="skuList.length !== 0">商品尺寸</th>
              <th>價格(TWD)</th>
              <th>價格(CNY)</th>
              <th>總庫存</th>
            </tr>
          </thead>
          <tbody v-if="skuList.length !== 0">
            <tr v-for="(item, index) in skuList" :key="index">
              <td>
                {{ item.value }}
              </td>
              <td>
                <input
                  type="text"
                  name=""
                  v-model="item.realPrice"
                  @change="
                    item.realPrice = item.realPrice
                      .replace(/[^0-9.]/g, '')
                      .replace(/^(\d+(\.\d{1,2})?).*$/, '\$1')
                  "
                />
              </td>
              <td>
                <input
                  type="text"
                  name=""
                  v-model="item.priceRmb"
                  @change="
                    item.priceRmb = item.priceRmb
                      .replace(/[^0-9.]/g, '')
                      .replace(/^(\d+(\.\d{1,2})?).*$/, '\$1')
                  "
                />
              </td>
              <td>
                <input
                  type="text"
                  name=""
                  id=""
                  v-model="item.realTotal"
                  @change="
                    item.realTotal = item.realTotal.replace(/^(0+)|[^\d]+/g, '')
                  "
                />
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td>
                <input
                  type="text"
                  name=""
                  v-model="skuRequest.realPrice"
                  @change="
                    skuRequest.realPrice = skuRequest.realPrice
                      .replace(/[^0-9.]/g, '')
                      .replace(/^(\d+(\.\d{1,2})?).*$/, '\$1')
                  "
                />
              </td>
              <td>
                <input
                  type="text"
                  name=""
                  v-model="skuRequest.priceRmb"
                  @change="
                    skuRequest.priceRmb = skuRequest.priceRmb
                      .replace(/[^0-9.]/g, '')
                      .replace(/^(\d+(\.\d{1,2})?).*$/, '\$1')
                  "
                />
              </td>
              <td>
                <input
                  type="text"
                  name=""
                  id=""
                  v-model="skuRequest.realTotal"
                  @change="
                    skuRequest.realTotal = skuRequest.realTotal.replace(
                      /^(0+)|[^\d]+/g,
                      ''
                    )
                  "
                />
              </td>
            </tr>
          </tbody>
        </table>
      </el-form-item>
    </el-form>
    <div class="detailsTitle">
      <div class="detailsWrap"></div>
      <p>詳細訊息</p>
    </div>

    <el-form>
      <el-form-item class="goodsAdd" label="注意事項:">
        <div
          class="goodsWrap"
          v-for="(item, index) in goodsService"
          :key="index"
        >
          <div class="goodsItem">
            <input v-model="item.fileUrl" class="el-input__inner" type="text" />
          </div>
          <span
            v-show="!(index === 0)"
            class="delBtn"
            @click="delGoodsItem(index, goodsService)"
            >删除</span
          >
        </div>

        <div
          v-show="goodsService.length < 3"
          class="addDetail"
          @click="addGoodesService()"
        >
          添加
        </div>
      </el-form-item>

      <div class="editor-wrap">
        <p class="editor-title normal_font">購買須知:</p>
        <Editor
          class="editor"
          style="color: #fff"
          @listenContent="getBuyContent"
          :colorFlag="true"
          :content="buyContent"
          :newsFlag="true"
          :id="editorBuyId"
        ></Editor>
      </div>

      <div class="editor-wrap">
        <p class="editor-title normal_font">商品介紹:</p>
        <Editor
          class="editor"
          style="color: #fff"
          @listenContent="getContent"
          :colorFlag="true"
          :content="content"
          :newsFlag="true"
          :id="editorId"
        ></Editor>
      </div>
    </el-form>

    <div class="bottomBtn">
      <div
        class="btn"
        v-if="type === 'edit' && goods.status === '已售完' && !shelfTime"
        @click="submitContent()"
      >
        保存
      </div>
      <div
        class="btn"
        v-else-if="type === 'edit' && goods.status === '已售完' && shelfTime"
        @click="submitContent()"
      >
        取消售罄并发布
      </div>
      <div class="btn" v-else @click="submitContent('open')">發佈</div>

      <div class="right" v-if="type !== 'edit'">
        <div class="btn borderPurpleBtn" @click="submitContent('caogao')">
          保存為草稿
        </div>
        <div class="btn borderPurpleBtn" @click="submitContent('yulan')">
          保存並預覽
        </div>
      </div>
    </div>
    <el-dialog
      title="提示信息"
      :visible.sync="uoloadModal"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="500px"
      center
    >
      <div class="dialog">
        <div>
          <el-upload
            ref="excelUpload"
            :action="this.$GLOBAL.productsPostUrl"
            :with-credentials="true"
            class="upload-demo"
            :headers="{ Authorization: this.$cookie.get('auth') }"
            drag
            :accept="'.xlsx,.xls'"
            :multiple="false"
            :file-list="fileList"
            :on-change="fileChange"
            :on-success="successExcel"
            :on-error="errorExcel"
            :auto-upload="false"
          >
            <img
              src="@/assets/images/common/blacklist_upload.png"
              alt="暂无数据"
              :style="{
                width: '41px',
                height: '41px',
                marginTop: '40px',
                marginBottom: '14px',
              }"
            />
            <div class="el-upload__text">
              將文件拖到此處，或<em>點擊上傳</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              只能上傳單個xlsx/xls文件，並且只根據上傳內容進行更新
            </div>
          </el-upload>
          <div class="btngroup">
            <div
              class="btn borderBtn"
              style="marginright: 112px"
              @click="uoloadModal = false"
            >
              取消
            </div>
            <div class="btn" @click="submitupdate">確認更新</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 新增運費模板 -->
    <el-dialog
      title="新增運費模板"
      :visible.sync="yunfeiModal"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="658px"
      center
      :show-close="false"
    >
      <div style="display: flex; align-items: center; justify-content: center">
        <div style="color: #878399; font-size: 14px">模板名稱：</div>
        <el-input
          style="width: 320px; margin-left: 20px"
          v-model="templateTitle"
          placeholder="請填寫模板名稱"
          maxlength="200"
        />
      </div>
      <div
        style="
          display: flex;
          margin-top: 20px;
          align-items: center;
          justify-content: center;
        "
      >
        <div style="color: #878399; font-size: 14px">運費模板：</div>
        <div style="margin-left: 20px">
          <el-upload
            ref="excelUploads"
            action=""
            :http-request="uploadRequest"
            :with-credentials="true"
            class="upload-demo"
            :headers="{ Authorization: this.$cookie.get('auth') }"
            drag
            :on-remove="yunfeiremove"
            :accept="'.xlsx,.xls'"
            :multiple="false"
            :auto-upload="true"
            :file-list="yunfeifileList"
            :on-change="handleFileChange"
          >
            <img
              src="@/assets/images/common/blacklist_upload.png"
              alt="暂无数据"
              :style="{
                width: '41px',
                height: '41px',
                marginTop: '40px',
                marginBottom: '14px',
              }"
            />
            <div class="el-upload__text">上傳運費模板</div>
          </el-upload>
        </div>
      </div>
      <div class="btngroup">
        <div
          class="btn borderBtn"
          style="margin-right: 40px"
          @click="cancelYunfei()"
        >
          取消
        </div>
        <div class="btn" @click="yunfeiupdate">新增</div>
      </div>
    </el-dialog>
    <!-- 運費模板列表 -->
    <el-dialog
      title="管理運費模板"
      :visible.sync="yunfeiListModal"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="45%"
      center
      @close="showYunfei('close')"
    >
      <div
        style="display: flex; justify-content: flex-end; align-items: center"
      >
        <el-button type="primary" @click="yunfeiModal = true"> 新增 </el-button>
        <el-button type="primary" @click="yufenExcel"> 下載運費模板 </el-button>
      </div>
      <table
        class="skuTables"
        :border="1"
        cellspacing="0"
        cellpadding="0"
        v-if="yunfeiData.length > 0"
      >
        <thead>
          <tr>
            <th style="width: 80%">運費模板名稱</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody v-for="(item, index) in yunfeiData" :key="index">
          <tr>
            <td style="width: 80%">{{ item.templateTitle }}</td>
            <td>
              <el-button @click="delExcel(item.id)" type="text"
                >刪除
              </el-button>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 20px;
        "
        v-else
      >
        <img
          src="@/assets/images/common/no_data.png"
          alt="暂无数据"
          :style="{ width: '244px', height: '139px' }"
        />
      </div>
      <div class="paging-block clearfix">
        <el-pagination
          class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="5"
          :pager-count="5"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-dialog>
    <!-- 文案模板列表 -->
    <el-dialog
      title="管理文案模板"
      :visible.sync="wenanListModal"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="45%"
      center
      @close="showWenan('close')"
    >
      <div
        style="display: flex; justify-content: flex-end; align-items: center"
      >
        <el-button type="primary" @click="wenanModal = true"> 新增 </el-button>
      </div>
      <table
        class="skuTables"
        :border="1"
        cellspacing="0"
        cellpadding="0"
        v-if="wenanData.length > 0"
      >
        <thead>
          <tr>
            <th style="width: 80%">模板名稱</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody v-for="(item, index) in wenanData" :key="index">
          <tr>
            <td style="width: 80%">{{ item.title }}</td>
            <td>
              <el-button @click="editWenan(item)" type="text">編輯 </el-button>
              <el-button
                style="color: red"
                @click="delWenan(item.id)"
                type="text"
                >刪除
              </el-button>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 20px;
        "
        v-else
      >
        <img
          src="@/assets/images/common/no_data.png"
          alt="暂无数据"
          :style="{ width: '244px', height: '139px' }"
        />
      </div>
      <div class="paging-block clearfix">
        <el-pagination
          class="paging fr"
          hide-on-single-page
          @current-change="handlePageChange"
          :current-page="page"
          :page-size="5"
          :pager-count="5"
          layout="prev, pager, next, jumper"
          :total="alltotal"
        >
        </el-pagination>
      </div>
    </el-dialog>
    <!-- 新增文案模板 -->
    <el-dialog
      :title="wenanId ? '編輯文案模板' : '新增文案模板'"
      :visible.sync="wenanModal"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="658px"
      center
      :show-close="false"
    >
      <div style="display: flex; align-items: center">
        <div style="color: #878399; font-size: 14px">模板名稱：</div>
        <el-input
          style="width: 320px; margin-left: 20px"
          v-model="wenanTitle"
          placeholder="請填寫模板名稱"
          maxlength="50"
        />
      </div>
      <div style="display: flex; margin-top: 10px">
        <div style="color: #878399; font-size: 14px; margin-top: 10px">
          提示文案：
        </div>
        <div style="flex: 1; margin-left: 20px">
          <div
            style="margin-top: 10px"
            v-for="(item, index) in tipList"
            :key="index"
          >
            <div class="common_flex" style="align-items: flex-start">
              <el-input
                type="textarea"
                style="width: 260px"
                placeholder="請輸入提交訂單提示文案"
                v-model="item.tipCn"
                :rows="3"
                resize="none"
                maxlength="200"
                v-if="surelanguageType[index] == 'cn'"
              />
              <el-input
                v-model="item.tipTw"
                type="textarea"
                style="width: 260px"
                placeholder="請輸入提交訂單提示文案"
                rows="3"
                resize="none"
                maxlength="200"
                v-if="surelanguageType[index] == 'tw'"
              />
              <el-input
                v-model="item.tipEn"
                type="textarea"
                style="width: 260px"
                :rows="3"
                resize="none"
                maxlength="200"
                placeholder="請輸入提交訂單提示文案"
                v-if="surelanguageType[index] == 'en'"
              />
              <div style="margin-left: 24px">
                <div
                  v-for="(items, indexs) in newslanguageList"
                  :key="indexs"
                  @click="changeLanguagesure(index, items.type)"
                  :class="indexs == 1 ? 'lglabel lbnone' : 'lglabel'"
                  :style="{
                    background:
                      surelanguageType[index] == items.type ? '#6C3DEA' : '',
                    color:
                      surelanguageType[index] == items.type
                        ? '#fff'
                        : '#6C3DEA',
                    display: 'inline-block',
                  }"
                >
                  {{ items.label }}
                </div>
                <div style="margin-top: 24px" class="common_flex">
                  <button
                    class="add_de_sure"
                    @click="addSurePrompt"
                    v-show="index == tipList.length - 1 && index < 19"
                  >
                    添加
                  </button>
                  <button
                    class="add_de_sure"
                    @click="delSurePrompt(index)"
                    v-show="index != 0 && index == tipList.length - 1"
                  >
                    刪除
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btngroup">
        <div
          class="btn borderBtn"
          style="margin-right: 40px"
          @click="cancelWenan()"
        >
          取消
        </div>
        <div class="btn" @click="wenanupdate">
          {{ wenanId ? "保存" : "新增" }}
        </div>
      </div>
    </el-dialog>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import Editor from "@/components/editor";
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";

export default {
  props: ["type", "id", "shelfTime"],
  data() {
    return {
      editorId: "contentId",
      editorBuyId: "buyContentId",
      vipPrice: false,
      yunfeiUrl: "",
      yunfeifileList: [],
      yunfeiData: [],
      goods: {
        name: "",
        freightTitle: "",
        freightId: "",
        type: 0,
        id: "",
        goodsType: 0,
        limited: "",
        listStatus: 1,
        goodsUserType: 0,
        shelfTime: "",
        status: "", // 商品的状态
        weight: "", // 商品规格-重量
        length: "", // 商品规格-长度
        width: "", // 商品规格-宽度
        height: "", // 商品规格-高度
        freight: "0", // 商品運費,
        vipTime: "",
        vipTimeCn: "",
        vipTimeTw: "",
        vipTimeEn: "",
        goodsVipId: "",
        payTime: 5,
        goodsGardenia: false,
        special: 0,
        numberMinDigit: "",
        numberMaxDigit: "",
        writeOffActivityId: "",
        mainland: 0,
        exchange: 0,
        refund: 0,
        listStartTime: "", //定時上架時間
        receiver: 0,
        orderPromptTitle: "",
        orderPromptId: "",
      },
      mainPicUrl: [], // 商品主图
      content: "", // 图文详情
      skuList: [],
      // 商品服务
      goodsService: [
        {
          type: 4,
          fileUrl: "",
          seq: 1,
          isDel: 1,
          remark: "",
        },
      ],
      // 購買須知
      buyContent: "",
      // 购买须知
      notesOfBuy: [
        {
          type: 5,
          fileUrl: "",
          seq: 1,
          isDel: 1,
          remark: "",
        },
      ],
      uploadData: {
        // 上传图片的附加参数
        flag: "xw",
      },
      dialogVisible: false,
      skuRequest: {
        realPrice: "",
        priceRmb: "",
        realTotal: "",
        vipRealPrice: null,
        vipPriceRmb: null,
      },
      skuType: 1,
      orderlanguageType: ["cn"],
      surelanguageType: ["cn"],
      newslanguageList: [
        {
          label: "简",
          type: "cn",
        },
        {
          label: "繁",
          type: "tw",
        },
        {
          label: "EN",
          type: "en",
        },
      ],
      tipList: [
        {
          tipCn: "",
          tipTw: "",
          tipEn: "",
        },
      ],
      languageType: "cn",
      tijiaolanguageType: "cn",
      uoloadModal: false,
      yunfeiModal: false,
      yunfeiListModal: false,
      fileList: [],
      demainland: 0,
      regex: false,
      promptList: [{ content: "", titleCn: "", titleTw: "", titleEn: "" }],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      timeType: 1,
      orderChoice: "",
      templateTitle: "",
      wenanTitle: "",
      currentPage: 1,
      total: 0,
      alltotal: 0,
      page: 1,
      wenanListModal: false,
      wenanModal: false,
      wenanData: [],
      wenanId: "",
    };
  },
  created() {
    let _this = this;
    _this.getYunfei();
    _this.getWenan();
    if (_this.type === "edit" || _this.type === "draft") {
      _this.getGoodsDetails();
    }
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    //添加订单详情提示
    addprompt() {
      this.promptList.push({
        content: "",
        titleCn: "",
        titleTw: "",
        titleEn: "",
      });
      this.orderlanguageType.push("cn");
    },
    //删除订单详情提示
    delprompt(index) {
      this.promptList.splice(index, 1);
      this.orderlanguageType.splice(index, 1);
    },
    //添加确认订单提示
    addSurePrompt() {
      this.tipList.push({
        tipCn: "",
        tipTw: "",
        tipEn: "",
      });
      this.surelanguageType.push("cn");
    },
    //删除确认订单提示
    delSurePrompt(index) {
      this.tipList.splice(index, 1);
      this.surelanguageType.splice(index, 1);
    },
    changeDistinguishArea() {
      this.goods.mainland = 1;
      this.demainland = 0;
    },
    uploadModal() {
      this.uoloadModal = true;
    },
    yufenExcel() {
      window.open(
        "https://start.sanctuarytech.co/uploads/template/mall_freight_template_20260731.xlsx"
      );
    },
    changePrice(e) {
      // console.log('666');

      if (!e) {
        if (this.skuList) {
          delete this.skuList.vipPriceRmb;
          delete this.skuList.vipRealPrice;
        }
        if (this.skuRequest) {
          delete this.skuRequest.vipPriceRmb;
          delete this.skuRequest.vipRealPrice;
        }
      }
    },
    fileChange(file, fileList) {
      this.fileList = fileList;
    },
    yunfeiremove(file, fileList) {
      if (fileList.length == 0) {
        this.yunfeiUrl = "";
      }
    },
    //刪除運費模板
    delExcel(id) {
      let _this = this;
      _this.dialogVisible = true;
      _this.$del(`/request/freight/${id}`).then((res) => {
        if (res.code == "00000") {
          if (_this.yunfeiData.length == 1 && _this.currentPage != 1) {
            _this.currentPage = _this.currentPage - 1;
          }
          _this.$propMessage("刪除成功", "success", function () {
            _this.dialogVisible = false;
            _this.goods.freightId = "";
            _this.goods.freightTitle = "";
            _this.getYunfei();
          });
        } else {
          _this.$propMessage(res.message, "error", function () {
            _this.dialogVisible = false;
          });
        }
      });
    },
    //刪除文案模板
    delWenan(id) {
      let _this = this;
      _this.dialogVisible = true;
      _this.$del(`/request/order/prompt/${id}`).then((res) => {
        if (res.code == "00000") {
          if (_this.wenanData.length == 1 && _this.page != 1) {
            _this.page = _this.page - 1;
          }
          _this.$propMessage("刪除成功", "success", function () {
            _this.dialogVisible = false;
            _this.goods.orderPromptId = "";
            _this.goods.orderPromptTitle = "";
            _this.getWenan();
          });
        } else {
          _this.$propMessage(res.message, "error", function () {
            _this.dialogVisible = false;
          });
        }
      });
    },
    //編文案模版
    editWenan(item) {
      this.wenanModal = true;
      this.wenanTitle = item.title;
      this.wenanId = item.id;
      for (let i = 0; i < item.tipList.length - 1; i++) {
        this.surelanguageType.push("cn");
      }
      this.tipList = item.tipList;
    },
    //重新上架
    onShelves() {
      let _this = this;
      let time = new Date().getTime();
      //比较当前时间和定时上架时间的大小
      if (time >= _this.shelfTime) {
        _this.dialogVisible = true;
        _this.$propMessage("售卖时间不能小于当前时间", "error", function () {
          _this.dialogVisible = false;
        });
        return;
      }
      let param = {
        goodsId: _this.id,
        status: 2,
        startTime: _this.shelfTime,
      };
      _this
        .$post(`/request/mall/updateStatus`, param, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          _this.dialogVisible = true;
          if (res.code === "00000") {
            _this.$propMessage("设置成功", "success", function () {
              _this.dialogVisible = false;
              _this.$router.go(-1);
            });
          } else {
            let time = new Date().getTime();
            //比较当前时间和定时上架时间的大小
            if (time >= this.listStartTime) {
              _this.$propMessage(
                "售卖时间不能小于当前时间",
                "error",
                function () {
                  _this.dialogVisible = false;
                }
              );
            } else {
              _this.$propMessage(res.message, "error", function () {
                _this.dialogVisible = false;
              });
            }
          }
        })
        .catch((err) => {
          _this.dialogVisible = true;
          _this.$propMessage(res.message, "error", function () {
            _this.dialogVisible = false;
          });
        });
    },
    // excel上传成功
    successExcel(res, file, fileList) {
      let _this = this;
      if (res.code === "00000") {
        console.log(res);
        _this.dialogVisible = true;
        _this.goods.goodsVipId = res.data.id;
        _this.$propMessage("名單更新成功", "success", function () {
          _this.dialogVisible = false;
        });
        _this.$refs.excelUpload.clearFiles();
        this.uoloadModal = false;
      } else {
        _this.dialogVisible = true;
        _this.$propMessage(res.message, "error", function () {
          _this.dialogVisible = false;
        });
        _this.$refs.excelUpload.clearFiles();
      }
    },
    // excel上传失败
    errorExcel(err, file, fileList) {
      let _this = this;
      _this.$refs.excelUpload.clearFiles();
      _this.dialogVisible = true;
      _this.$propMessage(err.message + ",請重新上傳", "error", function () {
        _this.dialogVisible = false;
      });
    },
    submitupdate() {
      this.$refs.excelUpload.submit();
    },
    handchange() {
      this.goods.numberMinDigit = "";
      this.goods.numberMaxDigit = "";
      this.goods.writeOffActivityId = "";
      if (this.goods.goodsType == 1 && this.goods.goodsUserType == 1) {
        this.goods.special = 2;
        this.goods.goodsInvisible = false;
        this.goods.goodsVipId = "";
      } else if (this.goods.goodsType == 1 && this.goods.goodsUserType == 0) {
        this.goods.special = 1;
      } else {
        this.goods.special = 0;
      }
      if (this.goods.goodsUserType == 0) {
        this.goods.type = 0;
      } else {
        this.goods.type = 1;
      }
      if (this.goods.goodsType == 2) {
        this.goods.goodsUserType = 1;
        this.goods.type = 2;
        this.vipPrice = false;
        this.changePrice(false);
      }
    },

    handchangeVip() {
      this.goods.vipTime = "";
      this.goods.vipTimeCn = "";
      this.goods.vipTimeTw = "";
      this.goods.vipTimeEn = "";
    },
    changeSpecial(e) {
      if (e == 2) {
        this.goods.goodsVipId = "";
        this.goods.goodsInvisible = false;
      }
    },
    downloadExcel() {
      window.open(
        "https://start.sanctuarytech.co/resource/excel/goods_vip.xlsx"
      );
    },
    //獲取運費模板
    getYunfei(type) {
      this.$get(
        `/request/freight/template?page=${this.currentPage}&size=5`,
        {},
        this.$GLOBAL.jsonConfig
      ).then((res) => {
        if (res.code == "00000") {
          this.yunfeiData = res.data.list;
          this.total = res.data.allRow;
          if (type == "modal") {
            this.yunfeiListModal = true;
          } else if (type == "close") {
            this.yunfeiListModal = false;
          }
        }
      });
    },
    //獲取運費模板
    getWenan(type) {
      this.$get(
        `/request/order/prompt/template?page=${this.page}&size=5`,
        {},
        this.$GLOBAL.jsonConfig
      ).then((res) => {
        if (res.code == "00000") {
          this.wenanData = res.data.list;
          this.alltotal = res.data.allRow;
          if (type == "modal") {
            this.wenanListModal = true;
          } else if (type == "close") {
            this.wenanListModal = false;
          }
        }
      });
    },
    showYunfei(type) {
      if (type == "close" && this.currentPage != 1) {
        this.currentPage = 1;
        this.getYunfei(type);
      } else if (type == "modal") {
        if (this.currentPage != 1) {
          this.currentPage = 1;
          this.getYunfei(type);
        } else {
          this.yunfeiListModal = true;
        }
      }
    },
    showWenan(type) {
      if (type == "close" && this.page != 1) {
        this.page = 1;
        this.getWenan(type);
      } else if (type == "modal") {
        if (this.page != 1) {
          this.page = 1;
          this.getWenan(type);
        } else {
          this.wenanListModal = true;
        }
      }
    },
    //获取编辑商品的商品详情
    getGoodsDetails() {
      let _this = this;
      _this
        .$post(
          `/request/mall/queryGoodsDetails?goodsId=${_this.id}`,
          _this.$GLOBAL.jsonConfig
        )
        .then((res) => {
          if (res.code === "00000") {
            let status = "";
            if (res.data[0].status == 0) {
              status = "已售完";
            } else if (res.data[0].status == 1) {
              status = "售賣中";
            } else if (res.data[0].status == 2) {
              status = "即將售賣";
            } else if (res.data[0].status == 3) {
              status = "已刪除";
            }
            _this.timeType = res.data[0].listStatus;
            _this.goods = {
              name: res.data[0].goodsName,
              type: res.data[0].goodsTerm, // 数字变为字符串
              limited: res.data[0].buyMaxNum,
              status: status,
              goodsType: res.data[0].goodsType,
              goodsUserType: res.data[0].goodsUserType,
              goodsNo: res.data[0].goodsNo,
              listStatus: res.data[0].listStatus,
              shelfTime: res.data[0].startTime
                ? _this.$getTime(res.data[0].startTime)
                : _this.$getTime(new Date()),
              listStartTime:
                res.data[0].listStartTime && res.data[0].listStatus == 0
                  ? _this.$getTime(res.data[0].listStartTime)
                  : null,
              weight: res.data[0].weight, // 商品规格-重量
              length: res.data[0].length, // 商品规格-长度
              width: res.data[0].width, // 商品规格-宽度
              height: res.data[0].height, // 商品规格-高度
              freight: res.data[0].shipFee,
              receiver: res.data[0].receiver,
              freightTitle: res.data[0].freightTitle,
              freightId: res.data[0].freightId,
              orderPromptTitle: res.data[0].orderPromptTitle,
              orderPromptId: res.data[0].orderPromptId
                ? Number(res.data[0].orderPromptId)
                : "",
              goodsVipId: res.data[0].goodsVipId ? res.data[0].goodsVipId : "",
              goodsInvisible: res.data[0].goodsInvisible == 1 ? true : false,
              special: res.data[0].special,
              payTime: res.data[0].payTime,
              vipTime: _this.$getTime(res.data[0].vipTime)
                ? _this.$getTime(res.data[0].vipTime)
                : "",
              vipTimeCn: res.data[0].vipTimeCn,
              vipTimeEn: res.data[0].vipTimeEn,
              vipTimeTw: res.data[0].vipTimeTw,
              goodsGardenia: res.data[0].goodsGardenia == 1 ? true : false,
              numberMaxDigit: res.data[0].numberMaxDigit,
              numberMinDigit: res.data[0].numberMinDigit,
              writeOffActivityId: res.data[0].writeOffActivityId,
              mainland: res.data[0].mainland,
              exchange: res.data[0].exchange,
            };
            this.promptList =
              res.data[0].promptList.length > 0
                ? res.data[0].promptList
                : [{ content: "", titleCn: "", titleTw: "", titleEn: "" }];
            // this.tipList =
            //   res.data[0].tipList.length > 0
            //     ? res.data[0].tipList
            //     : [{ titleCn: "", titleTw: "", titleEn: "" }];
            _this.skuType = res.data[0].skuType;
            if (_this.skuType === 0) {
              _this.skuRequest =
                _this.type == "edit" && status != "即將售賣"
                  ? ""
                  : res.data[0].skuRequest;
              _this.vipPrice = res.data[0].skuRequest.vipRealPrice
                ? true
                : false;
            } else {
              _this.skuList =
                _this.type == "edit" && status != "即將售賣"
                  ? ""
                  : res.data[0].skuRequestList;
              _this.vipPrice = res.data[0].skuRequestList[0].vipRealPrice
                ? true
                : false;
            }
            if (res.data[0].promptList.length > 0) {
              for (let i = 0; i < res.data[0].promptList.length - 1; i++) {
                this.orderlanguageType.push("cn");
              }
            }
            // if (res.data[0].tipList.length > 0) {
            //   for (let i = 0; i < res.data[0].tipList.length - 1; i++) {
            //     this.surelanguageType.push("cn");
            //   }
            // }
            // 图片列表
            for (let i in res.data[0].accessoryDto.imgUrl) {
              _this.mainPicUrl.push({
                name: "img.jpg",
                url: res.data[0].accessoryDto.imgUrl[i].imgUrlStr,
              });
            }
            console.log(_this.mainPicUrl);

            // 商品服务
            _this.goodsService = [];
            for (let j in res.data[0].accessoryDto.goodsServicesList) {
              _this.goodsService.push({
                type: 4,
                fileUrl:
                  res.data[0].accessoryDto.goodsServicesList[j]
                    .goodsServicesStr,
                seq: Number(j) + 1,
                isDel: 1,
                remark: "",
              });
            }
            // 购买须知
            this.buyContent = "";
            for (let k in res.data[0].accessoryDto.purchaseNotesDtoList) {
              this.buyContent =
                this.buyContent +
                res.data[0].accessoryDto.purchaseNotesDtoList[k].mainDody;
            }
            // 商品介紹
            _this.content = res.data[0].accessoryDto.graphicDetails;
          } else {
            _this.$propMessage(res.message, "error");
          }
        });
    },
    changeLanguage(type) {
      this.languageType = type;
    },
    changeLanguageshop(type) {
      this.tijiaolanguageType = type;
    },
    changeLanguageorder(index, type) {
      this.$set(this.orderlanguageType, index, type);
    },
    changeLanguagesure(index, type) {
      this.$set(this.surelanguageType, index, type);
    },
    changefreight(val) {
      const selectedItem = this.yunfeiData.find((item) => item.id == val);
      this.goods.freightTitle = selectedItem.templateTitle;
    },
    changeWenan(val) {
      const selectedItem = this.wenanData.find((item) => item.id == val);
      this.goods.orderPromptTitle = selectedItem.title;
    },
    changeYunfei() {
      this.goods.freightId = "";
      this.goods.freightTitle = "";
    },
    fenyeNext() {},
    // 图片上传之前的回调函数
    beforePicUpload(file) {
      let _this = this;
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        _this.dialogVisible = true;
        _this.$propMessage(
          "上傳圖片只能是jpg或者png格式",
          "error",
          function () {
            _this.dialogVisible = false;
          }
        );
        return false;
      }
      if (!isLt2M) {
        _this.dialogVisible = true;
        _this.$propMessage("上傳圖片大小不能超過2MB", "error", function () {
          _this.dialogVisible = false;
        });
        return false;
      }
      const isSize = new Promise(function (resolve, reject) {
        let width = 500;
        let height = 500;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function () {
          let valid = img.width === width && img.height === height;
          valid ? resolve() : reject(new Error());
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          return file;
        },
        () => {
          _this.dialogVisible = true;
          _this.$propMessage("上傳圖片大小需為500*500！", "error", function () {
            _this.dialogVisible = false;
          });
          return Promise.reject(new Error());
        }
      );
      return isJPG && isLt2M && isSize;
    },
    handchangeSpecial() {
      this.goods.writeOffActivityId = "";
      this.goods.numberMaxDigit = "";
      this.goods.numberMinDigit = "";
    },
    // 移除图片的回调函数
    handleRemove(file, fileList) {
      let _this = this;
      _this.$deleteUidItem(file.uid, _this.mainPicUrl);
      if (_this.mainPicUrl.length < 5) {
        document.getElementsByClassName("el-upload")[0].style.display =
          "inline-block";
      }
    },
    uploadRequest(option) {
      const file = option.file;
      const self = this;
      return new Promise((resolve, reject) => {
        // 判断文件类型
        const fileType = file.name.split(".").pop().toLowerCase();
        const isExcel = ["xls", "xlsx", "csv"].includes(fileType);

        const date = self.$dateFormat(new Date(), "yyyy-MM-dd");
        const dateTime = self.$dateFormat(new Date(), "yyyyMMddhhmmss");
        let randomStr = self.$randomString(4);
        const extensionName = file.name.substr(file.name.indexOf("."));

        // 根据文件类型选择存储路径
        const fileWay = isExcel ? "uploads/template/" : "resource/image/";
        const fileName =
          fileWay + date + "/" + dateTime + "_" + randomStr + extensionName;

        self.$createOssClient().then((client) => {
          // 如果是Excel文件，可以设置不同的headers或额外配置
          const headers = isExcel
            ? {
                "Cache-Control": "public",
                "Content-Type":
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              }
            : { "Cache-Control": "public" };

          client.multipartUpload(fileName, file, { headers }).then(
            (val) => {
              if (val.res.statusCode === 200) {
                if (isExcel) {
                  // Excel文件上传成功后的处理
                  // 例如：存储到不同的数组或触发不同的回调
                  self.yunfeiUrl = self.$GLOBAL.picFileUrl + val.name;
                  console.log(self.yunfeiUrl);
                  // 如果有Excel相关的处理逻辑
                  option.onSuccess &&
                    option.onSuccess({
                      fileName: file.name,
                      fileUrl: self.yunfeiUrl,
                    });
                } else {
                  // 图片上传成功后的处理（原有逻辑）
                  self.mainPicUrl.push({
                    name: "img.jpg",
                    url:
                      self.$GLOBAL.picFileUrl + val.name + self.$GLOBAL.xwPic,
                  });
                  console.log(self.mainPicUrl[0].url);

                  // cdn预热
                  self.$cdnFun(self.mainPicUrl[0].url).then((res) => {
                    console.log(res);
                  });
                  if (self.mainPicUrl.length === 5) {
                    document.getElementsByClassName(
                      "el-upload"
                    )[0].style.display = "none";
                  }
                }
                resolve(val);
              } else {
                option.onError("上传失败1");
                reject(new Error("上传失败1"));
              }
            },
            (err) => {
              console.log(err);
              option.onError("上传失败");
              reject(err);
            }
          );
        });
      });
    },
    // 增加sku
    addSku() {
      let _this = this;
      let length = _this.skuList.length;
      _this.skuList.push({
        turn: Number(length + 1),
        value: "",
        realPrice: "",
        priceRmb: "",
        realTotal: "",
      });
    },
    // 增加商品服务
    addGoodesService() {
      let _this = this;
      let length = _this.goodsService.length;
      _this.goodsService.push({
        type: 4,
        fileUrl: "",
        seq: Number(length + 1),
        isDel: 1,
        remark: "",
      });
    },
    // 删除列表
    delGoodsItem(index, itemList) {
      itemList.splice(index, 1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getYunfei();
    },
    handlePageChange(val) {
      this.page = val;
      this.getWenan();
    },
    // 实时获取商品介紹
    getContent(data) {
      let _this = this;
      _this.content = data;
    },
    // 實時獲取購買須知
    getBuyContent(data) {
      let _this = this;
      _this.buyContent = data;
    },
    timingChange() {
      this.goods.listStartTime = "";
    },
    submitFn(sort) {
      let _this = this;
      let htmlStr = _this.content.replace(
        /<p>(\s*<img[^>]*>\s*)<\/p>/g,
        "<div>$1</div>"
      );
      //修改图片上边距过短问题
      // let html = htmlStr.replace(/<div([^>]*)>/g, '<div\$1 style="margin-top: 10px;">');
      //   _this.content = html;
      _this.content = htmlStr;

      // console.log(_this.content);

      //確認發佈
      let imgList = [];
      for (var i in _this.mainPicUrl) {
        imgList.push({
          type: 1,
          fileUrl: _this.mainPicUrl[i].url,
          seq: Number(Number(i) + 1),
          isDel: 1,
          remark: "",
        });
      }
      let contentParam = {
        type: 2,
        fileUrl: _this.content,
        seq: 1,
        isDel: 1,
        remark: "",
      };
      // console.log("contentParam", contentParam);

      let buyContentParam = {
        type: 5,
        fileUrl: _this.buyContent,
        seq: 1,
        isDel: 1,
        remark: "",
      };
      let status = "";
      if (sort == "add") {
        if (_this.goods.shelfTime) {
          //定時發佈
          status = 2; //即將售賣
        } else {
          status = 1; //售卖中
        }
      } else if (sort == "edit" && !this.shelfTime) {
        if (_this.goods.status == "已售完") {
          status = 0;
        } else if (_this.goods.status == "售賣中" || !_this.goods.shelfTime) {
          status = 1;
        } else {
          status = 2;
        }
      } else if (sort == "edit" && this.shelfTime) {
        status = 2;
      }
      let goodsInvisible = "";
      if (_this.goods.goodsInvisible) {
        goodsInvisible = 1;
      } else {
        goodsInvisible = 0;
      }
      //循环判断promptList是否有空的提示信息
      _this.promptList = _this.promptList.filter(
        (item) =>
          !(
            item.content === "" &&
            item.titleCn === "" &&
            item.titleTw === "" &&
            item.titleEn === ""
          )
      );
      //增加商品提交
      if (_this.type === "add" || _this.type === "draft") {
        let param = {
          length: _this.goods.length,
          weight: _this.goods.weight,
          height: _this.goods.height,
          width: _this.goods.width,
          goodsTitle: _this.goods.name,
          goodsTerm: Number(_this.goods.type), // 全部0或者vip1
          goodsType: _this.goods.goodsType,
          goodsUserType: _this.goods.goodsUserType,
          type: 5, // 商城的商品
          maxBuyNum: _this.goods.limited,
          status: status,
          goodsNo: _this.goods.goodsNo, // 订单编号
          isCron: _this.goods.listStatus == 1 ? 0 : 1,
          listStatus: _this.goods.listStatus,
          refund: _this.goods.refund,
          exchange: _this.goods.exchange,
          startTime: _this.goods.shelfTime
            ? _this.$dayjs(_this.goods.shelfTime).format("YYYY-MM-DD HH:mm:ss")
            : _this.$getTime(new Date()),
          listStartTime:
            _this.goods.listStatus == 0
              ? _this
                  .$dayjs(_this.goods.listStartTime)
                  .format("YYYY-MM-DD HH:mm:ss")
              : null,
          img: _this.mainPicUrl[0].url,
          goodsVipId: goodsInvisible == 1 ? _this.goods.goodsVipId : "",
          special: _this.goods.special,
          goodsInvisible: goodsInvisible,
          promptList: _this.promptList,
          payTime: _this.goods.payTime,
          vipTime: _this.goods.vipTime
            ? _this.$dayjs(_this.goods.vipTime).format("YYYY-MM-DD HH:mm:ss")
            : "",
          vipTimeCn: _this.goods.vipTimeCn,
          vipTimeTw: _this.goods.vipTimeTw,
          vipTimeEn: _this.goods.vipTimeEn,
          goodsGardenia: _this.goods.goodsGardenia ? 0 : 1,
          goodsAttachList: _this.goodsService
            .concat(buyContentParam)
            .concat(imgList)
            .concat(contentParam),
          shipFee: _this.goods.freight,
          freightId: _this.goods.freight == 1 ? _this.goods.freightId : null,
          receiver: _this.goods.receiver,
          freightTitle:
            _this.goods.freight == 1 ? _this.goods.freightTitle : null,
          skuType: this.skuType,
          draft: 0,
          writeOffActivityId: _this.goods.writeOffActivityId,
          numberMinDigit: _this.goods.numberMinDigit,
          numberMaxDigit: _this.goods.numberMaxDigit,
          mainland: _this.goods.mainland,
          orderPromptTitle: _this.goods.orderPromptTitle,
          orderPromptId: _this.goods.orderPromptId
            ? Number(_this.goods.orderPromptId)
            : "",
        };

        if (this.skuType === 1) {
          param.skuRequestList = this.skuList;
          param.goodsPrice = _this.skuList[0].realPrice;
        } else {
          param.skuRequest = this.skuRequest;
          param.goodsPrice = this.skuRequest.realPrice;
        }
        _this
          .$post("/request/mall/saveGoods", param, _this.$GLOBAL.jsonConfig)
          .then((res) => {
            _this.dialogVisible = true;
            if (res.code === "00000") {
              _this.$propMessage("新增商品成功", "success", function () {
                _this.dialogVisible = false;
                _this.$router.push("/goodsList");
              });
            } else {
              if (_this.promptList.length == 0) {
                _this.promptList.push({
                  content: "",
                  titleCn: "",
                  titleTw: "",
                  titleEn: "",
                });
              }

              _this.$propMessage(res.message, "error", function () {
                _this.dialogVisible = false;
              });
            }
          })
          .catch((err) => {
            if (_this.promptList.length == 0) {
              _this.promptList.push({
                content: "",
                titleCn: "",
                titleTw: "",
                titleEn: "",
              });
            }
            _this.$propMessage(err.error, "error", function () {
              _this.dialogVisible = false;
            });
          });
      } else if (_this.type === "edit") {
        // 编辑商品提交
        let startTime = "";
        if (_this.goods.status === "即將售賣") {
          if (typeof _this.goods.shelfTime === "string") {
            // 回显的上架时间没有修改
            startTime = _this.goods.shelfTime;
          } else {
            // 回显的上架时间修改，即为标准时间格式，需要变更格式
            startTime = _this.goods.shelfTime
              ? _this.$formatDate(_this.goods.shelfTime)
              : "";
          }
        } else if (_this.goods.status === "售賣中") {
          // 其他状态下，上架时间无法修改，即为字符串格式，不需变更格式
          startTime = _this.goods.shelfTime;
        } else {
          startTime = _this.shelfTime;
        }
        let goodsInvisible = "";
        if (_this.goods.goodsInvisible) {
          goodsInvisible = 1;
        } else {
          goodsInvisible = 0;
        }
        let editParam = [
          {
            maxBuyNum: _this.goods.limited,
            goodsAttachList: _this.goodsService
              .concat(buyContentParam)
              .concat(imgList)
              .concat(contentParam),
            imgUrl: _this.mainPicUrl[0].url,
            goodsId: _this.id, // 订单的id
            goodsName: _this.goods.name,
            goodsNo: _this.goods.goodsNo, // 订单编号
            goodsTerm: Number(_this.goods.type), // 全部0或者vip1
            goodsType: _this.goods.goodsType,
            goodsUserType: _this.goods.goodsUserType,
            // goodsPrice:this.skuType == 1?_this.skuList[0].realPrice:this.skuRequest.realPrice,
            type: 5, // 商城的商品
            height: _this.goods.height,
            length: _this.goods.length,
            weight: _this.goods.weight,
            width: _this.goods.width,
            status: status,
            goodsVipId: goodsInvisible == 1 ? _this.goods.goodsVipId : "",
            special: _this.goods.special,
            goodsInvisible: goodsInvisible,
            promptList: _this.promptList,
            payTime: _this.goods.payTime,
            vipTime: _this.goods.vipTime
              ? _this.$dayjs(_this.goods.vipTime).format("YYYY-MM-DD HH:mm:ss")
              : "",
            vipTimeCn: this.goods.vipTimeCn,
            vipTimeTw: this.goods.vipTimeTw,
            vipTimeEn: this.goods.vipTimeEn,
            goodsGardenia: _this.goods.goodsGardenia ? 0 : 1,
            isCron: _this.goods.listStatus == 1 ? 0 : 1,
            listStatus: _this.goods.listStatus,
            refund: _this.goods.refund,
            exchange: _this.goods.exchange,
            startTime: startTime
              ? _this.$dayjs(startTime).format("YYYY-MM-DD HH:mm:ss")
              : _this.$getTime(new Date()),
            listStartTime: _this.goods.listStartTime
              ? _this
                  .$dayjs(_this.goods.listStartTime)
                  .format("YYYY-MM-DD HH:mm:ss")
              : null,
            writeOffActivityId: _this.goods.writeOffActivityId,
            numberMinDigit: _this.goods.numberMinDigit,
            numberMaxDigit: _this.goods.numberMaxDigit,
            shipFee: _this.goods.freight,
            freightId: _this.goods.freight == 1 ? _this.goods.freightId : null,
            receiver: _this.goods.receiver,
            freightTitle:
              _this.goods.freight == 1 ? _this.goods.freightTitle : null,
            skuType: _this.skuType,
            draft: 0,
            mainland: _this.goods.mainland,
            orderPromptTitle: _this.goods.orderPromptTitle,
            orderPromptId: _this.goods.orderPromptId
              ? Number(_this.goods.orderPromptId)
              : "",
          },
        ];
        if (_this.goods.status === "即將售賣") {
          if (this.skuType === 1) {
            editParam[0].skuRequestList = this.skuList;
          } else {
            editParam[0].skuRequest = this.skuRequest;
          }
        }
        _this
          .$post(
            "/request/mall/updateGoodsDetails",
            editParam,
            _this.$GLOBAL.jsonConfig
          )
          .then((res) => {
            _this.dialogVisible = true;
            if (res.code === "00000") {
              if (_this.shelfTime) {
                _this.onShelves();
              } else {
                _this.$propMessage("編輯商品成功", "success", function () {
                  _this.dialogVisible = false;
                  _this.$router.push("/goodsList");
                });
              }
            } else {
              if (_this.promptList.length == 0) {
                _this.promptList.push({
                  content: "",
                  titleCn: "",
                  titleTw: "",
                  titleEn: "",
                });
              }
              _this.$propMessage(res.message, "error", function () {
                _this.dialogVisible = false;
              });
            }
          })
          .catch((err) => {
            if (_this.promptList.length == 0) {
              _this.promptList.push({
                content: "",
                titleCn: "",
                titleTw: "",
                titleEn: "",
              });
            }
            _this.$propMessage(err.error, "error", function () {
              _this.dialogVisible = false;
            });
          });
      }
    },
    checkData(list) {
      if (list.length == 0) {
        return true;
      } else {
        for (let i = 0; i < list.length; i++) {
          const item = list[i];
          if (
            (!item.titleCn &&
              !item.titleTw &&
              !item.titleEn &&
              !item.content) ||
            (item.titleCn && item.titleTw && item.titleEn)
          ) {
            this.regex = true;
          } else {
            this.regex = false;
            return this.regex;
          }
        }
        return this.regex;
      }
    },
    checkContent(list) {
      let check = true;
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        if (item.titleCn || item.titleTw || item.titleEn) {
          if (!item.content) {
            check = false;
            return false;
          } else {
            check = true;
          }
        }
      }
      return check;
    },
    // 提交商品（新增或编辑）
    submitContent(sort) {
      let _this = this;
      if (_this.goods.name === "" || _this.$getCaption(_this.goods.name)) {
        _this.dialogVisible = true;
        _this.$propMessage(
          "商品名稱不能為空或者含有非法字符",
          "error",
          function () {
            _this.dialogVisible = false;
          }
        );
        return false;
      }
      if (!_this.goods.freightId && _this.goods.freight == 1) {
        _this.dialogVisible = true;
        _this.$propMessage("請選擇運費模板", "error", function () {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (_this.goods.limited === "") {
        _this.dialogVisible = true;
        _this.$propMessage("商品限購數量不能為空", "error", function () {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (_this.mainPicUrl.length === 0) {
        _this.dialogVisible = true;
        _this.$propMessage("商品主圖不能為空", "error", function () {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (
        _this.goods.weight === "" ||
        _this.goods.width === "" ||
        _this.goods.length === "" ||
        _this.goods.height === ""
      ) {
        _this.dialogVisible = true;
        _this.$propMessage("商品規格不能有選項為空", "error", function () {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (_this.goods.type == 3) {
        if (!_this.goods.vipTime) {
          _this.$warnMessage("請選擇會員截至時間");
          return;
        }
        if (
          !_this.goods.vipTimeCn ||
          !_this.goods.vipTimeEn ||
          !_this.goods.vipTimeTw
        ) {
          _this.$warnMessage("提示文案不能爲空");
          return;
        }
      }
      if (_this.goods.goodsInvisible && _this.goods.goodsVipId === "") {
        _this.$warnMessage("請上傳表格");
        return;
      }
      if (_this.goods.goodsType == 1) {
        if (_this.goods.writeOffActivityId === "" && _this.goods.special == 2) {
          _this.$warnMessage("核銷活動ID不能爲空");
          return;
        }
        if (_this.goods.numberMinDigit === "") {
          _this.$warnMessage("最小數字不能爲空");
          return;
        }
        if (_this.goods.numberMaxDigit === "") {
          _this.$warnMessage("最大數字不能爲空");
          return;
        }
        if (
          Number(_this.goods.numberMaxDigit) <
          Number(_this.goods.numberMinDigit)
        ) {
          _this.$warnMessage("最大數字不能小於最小數字");
          return;
        }
        if (
          _this.goods.numberMaxDigit > 99999 ||
          _this.goods.numberMinDigit > 99999
        ) {
          _this.$warnMessage("幸運數字不能超過99999");
          return;
        }
        const regex = /^0\d{1,}/;
        if (
          regex.test(_this.goods.numberMinDigit) ||
          regex.test(_this.goods.numberMaxDigit)
        ) {
          _this.$warnMessage("幸運數字格式错误");
          return;
        }
      }

      if (
        _this.type === "add" ||
        _this.type === "draft" ||
        (_this.type === "edit" && _this.goods.status === "即將售賣")
      ) {
        if (_this.goods.listStatus == 0) {
          // 定時
          let timeFormat = _this.$compareTime(
            _this.goods.listStartTime,
            new Date()
          );
          if (_this.goods.listStartTime === null || timeFormat === false) {
            _this.dialogVisible = true;
            _this.$propMessage(
              "定時發佈時間不能為空，且只能設置未來時間",
              "error",
              function () {
                _this.dialogVisible = false;
              }
            );
            return false;
          }
        }
      }
      // let cozyTip = _this.tipList.filter(
      //   item => item.titleCn && item.titleTw && item.titleEn
      // );
      // if (cozyTip.length != _this.tipList.length) {
      //   _this.$warnMessage("請輸入确认订单温馨提示");
      //   return;
      // }
      let list;
      if (_this.promptList.length > 1) {
        list = _this.promptList.filter(
          (item) =>
            !(
              item.content === "" &&
              item.titleCn === "" &&
              item.titleTw === "" &&
              item.titleEn === ""
            )
        );
      } else {
        list = _this.promptList;
      }
      if (!this.checkData(list)) {
        _this.$warnMessage("訂單詳情提示標題不能爲空");
        return;
      }
      if (!this.checkContent(list)) {
        _this.$warnMessage("訂單詳情提示内容不能爲空");
        return;
      }
      // 编辑商品不能编辑sku，故只有新增商品判断sku是否为空
      if (_this.type === "add" || _this.type === "draft") {
        if (_this.skuList.length > 0) {
          if (_this.skuList.length === 1 && _this.skuList[0].value === "") {
            _this.dialogVisible = true;
            _this.$propMessage("商品SKU不能為空", "error", function () {
              _this.dialogVisible = false;
            });
            return false;
          }

          this.skuType = 1;
          for (var i in _this.skuList) {
            if (
              _this.skuList[i].realPrice === "" ||
              _this.skuList[i].priceRmb === "" ||
              _this.skuList[i].value === "" ||
              _this.skuList[i].realTotal === "" ||
              _this.$getCaption(_this.skuList[i].value)
            ) {
              _this.dialogVisible = true;
              _this.$propMessage(
                "商品SKU不能有選項為空或者含有非法字符",
                "error",
                function () {
                  _this.dialogVisible = false;
                }
              );
              return false;
            }
          }
          if (this.vipPrice) {
            for (var j in _this.skuList) {
              if (
                _this.skuList[j].vipRealPrice === "" ||
                _this.skuList[j].vipPriceRmb === ""
              ) {
                _this.dialogVisible = true;
                _this.$propMessage(
                  "商品SKU不能有選項為空或者含有非法字符",
                  "error",
                  function () {
                    _this.dialogVisible = false;
                  }
                );
                return false;
              }
            }
          }
        } else {
          this.skuType = 0;
          if (
            this.skuRequest.realPrice === "" ||
            this.skuRequest.priceRmb === "" ||
            this.skuRequest.realTotal === ""
          ) {
            _this.dialogVisible = true;
            _this.$propMessage(
              "商品SKU不能有選項為空或者含有非法字符",
              "error",
              function () {
                _this.dialogVisible = false;
              }
            );
            return false;
          }
          if (this.vipPrice) {
            if (
              this.skuRequest.vipRealPrice == "" ||
              this.skuRequest.vipPriceRmb == ""
            ) {
              _this.dialogVisible = true;
              _this.$propMessage(
                "商品SKU不能有選項為空或者含有非法字符",
                "error",
                function () {
                  _this.dialogVisible = false;
                }
              );
              return false;
            }
          }
        }
      }

      if (
        _this.goodsService.length === 1 &&
        _this.goodsService[0].fileUrl === ""
      ) {
        _this.dialogVisible = true;
        _this.$propMessage("注意事項不能為空", "error", function () {
          _this.dialogVisible = false;
        });

        return false;
      }

      for (var j in _this.goodsService) {
        if (
          _this.goodsService[j].fileUrl === "" ||
          _this.$getCaption(_this.goodsService[j].fileUrl)
        ) {
          _this.dialogVisible = true;
          _this.$propMessage(
            "注意事項不能有選項為空或者含有非法字符",
            "error",
            function () {
              _this.dialogVisible = false;
            }
          );
          return false;
        }
      }

      if (_this.buyContent === "") {
        _this.dialogVisible = true;
        _this.$propMessage("購買須知不能為空", "error", function () {
          _this.dialogVisible = false;
        });
        return false;
      }

      if (_this.content === "" || _this.content === null) {
        _this.dialogVisible = true;
        _this.$propMessage("商品介紹不能為空", "error", function () {
          _this.dialogVisible = false;
        });
        return false;
      }

      if (_this.type === "edit") {
        _this.submitFn("edit");
      } else if (sort == "open") {
        _this
          .$confirm(
            "是否發佈該商品，發佈後將在商品列表中展示商品。確定發佈該商品嗎?",
            "提示信息",
            {
              confirmButtonText: "確認",
              cancelButtonText: "取消",
              center: true,
              closeOnClickModal: false,
            }
          )
          .then(() => {
            _this.submitFn("add");
          })
          .catch(() => {
            _this.$propMessage(err.error, "error", function () {
              _this.dialogVisible = false;
            });
          });
      } else if (sort == "caogao") {
        _this.saveContent("caogao");
      } else {
        _this.saveContent("yulan");
      }
    },
    // 通过正则过滤小数点后两位
    handlePriceInput(e) {
      e.value = e.value.match(/^\d*(\.?\d{0,1})/g)[0] || null;
    },
    // 保存並預覽
    saveContent(preview) {
      let _this = this;

      if (_this.goods.name === "" || _this.$getCaption(_this.goods.name)) {
        _this.dialogVisible = true;
        _this.$propMessage(
          "商品名稱不能為空或者含有非法字符",
          "error",
          function () {
            _this.dialogVisible = false;
          }
        );
        return false;
      }
      let imgList = [];
      if (_this.mainPicUrl.length !== 0) {
        for (var i in _this.mainPicUrl) {
          imgList.push({
            type: 1,
            fileUrl: _this.mainPicUrl[i].url,
            seq: Number(Number(i) + 1),
            isDel: 1,
            remark: "",
          });
        }
      }
      let htmlStr = this.content.replace(
        /<p>(\s*<img[^>]*>\s*)<\/p>/g,
        "<div>$1</div>"
      );
      //修改图片上边距过短问题
      // let html = htmlStr.replace(/<div([^>]*)>/g, '<div\$1 style="margin-top: 10px;">');
      //   _this.content = html;
      this.content = htmlStr;
      let contentParam = {
        type: 2,
        fileUrl: _this.content,
        seq: 1,
        isDel: 1,
        remark: "",
      };
      let buyContentParam = {
        type: 5,
        fileUrl: _this.buyContent,
        seq: 1,
        isDel: 1,
        remark: "",
      };
      let goodsPrice =
        this.skuList.length > 0
          ? _this.skuList[0].realPrice
          : _this.skuRequest.realPrice;
      let goodsInvisible = "";
      if (_this.goods.goodsInvisible) {
        goodsInvisible = 1;
      } else {
        goodsInvisible = 0;
      }
      let status = "";
      if (_this.goods.shelfTime) {
        //定時發佈
        status = 2; //即將售賣
      } else {
        status = 1; //售卖中
      }
      if (_this.skuList.length > 0) {
        _this.skuType = 1;
      } else {
        _this.skuType = 0;
      }
      if (
        _this.promptList[0].content == "" ||
        _this.promptList[0].titleCn == "" ||
        _this.promptList[0].titleEn == "" ||
        _this.promptList[0].titleTw == ""
      ) {
        _this.promptList = [];
      }
      let param = null;

      if (!_this.id) {
        param = {
          length: _this.goods.length,
          weight: _this.goods.weight,
          height: _this.goods.height,
          width: _this.goods.width,
          goodsPrice: goodsPrice,
          goodsTitle: _this.goods.name,
          goodsType: _this.goods.goodsType,
          goodsUserType: _this.goods.goodsUserType,
          type: 5, // 商城的商品
          goodsTerm: Number(_this.goods.type), // 全部0或者vip1
          maxBuyNum: _this.goods.limited,
          status: status,
          isCron: _this.goods.listStatus == 1 ? 0 : 1,
          img: _this.mainPicUrl.length === 0 ? "" : _this.mainPicUrl[0].url,
          goodsVipId: goodsInvisible == 1 ? _this.goods.goodsVipId : "",
          special: _this.goods.special,
          goodsInvisible: goodsInvisible,
          promptList: _this.promptList,
          goodsNo: _this.goods.goodsNo,
          payTime: _this.goods.payTime,
          vipTimeCn: _this.goods.vipTimeCn,
          vipTimeTw: _this.goods.vipTimeTw,
          vipTimeEn: _this.goods.vipTimeEn,
          vipTime: _this.goods.vipTime
            ? _this.$dayjs(_this.goods.vipTime).format("YYYY-MM-DD HH:mm:ss")
            : "",
          listStatus: _this.goods.listStatus,
          refund: _this.goods.refund,
          exchange: _this.goods.exchange,
          startTime: _this.goods.shelfTime
            ? _this.$dayjs(_this.goods.shelfTime).format("YYYY-MM-DD HH:mm:ss")
            : _this.$getTime(new Date()),
          listStartTime: _this.goods.listStartTime
            ? _this
                .$dayjs(_this.goods.listStartTime)
                .format("YYYY-MM-DD HH:mm:ss")
            : null,
          goodsGardenia: _this.goods.goodsGardenia ? 0 : 1,
          goodsAttachList: _this.goodsService
            .concat(buyContentParam)
            .concat(imgList)
            .concat(contentParam),
          shipFee: _this.goods.freight,
          freightId: _this.goods.freight == 1 ? _this.goods.freightId : null,
          receiver: _this.goods.receiver,
          freightTitle:
            _this.goods.freight == 1 ? _this.goods.freightTitle : null,
          skuType: this.skuList.length > 0 ? 1 : 0,
          skuRequest: this.skuRequest,
          draft: 1,
          skuRequestList: _this.skuList,
          writeOffActivityId: _this.goods.writeOffActivityId,
          numberMinDigit: _this.goods.numberMinDigit,
          numberMaxDigit: _this.goods.numberMaxDigit,
          mainland: _this.goods.mainland,
          orderPromptTitle: _this.goods.orderPromptTitle,
          orderPromptId: _this.goods.orderPromptId
            ? Number(_this.goods.orderPromptId)
            : "",
        };
        if (this.skuType === 1) {
          param.skuRequestList = this.skuList;
          // param.gogdsPrice = _this.skuList[0].realPrice;
        } else {
          param.skuRequest = this.skuRequest;
          // param.gogdsPrice = this.skuRequest.realPrice;
        }
      } else {
        let startTime = "";
        // if (_this.goods.status === "即將售賣") {
        //   startTime = _this.$dayjs(_this.goods.shelfTime).format("YYYY-MM-DD HH:mm:ss");
        // } else {
        //   // 其他状态下，上架时间无法修改，即为字符串格式，不需变更格式
        //   startTime = _this.goods.shelfTime;
        // }
        param = [
          {
            length: _this.goods.length,
            weight: _this.goods.weight,
            height: _this.goods.height,
            width: _this.goods.width,
            goodsPrice: goodsPrice,
            goodsName: _this.goods.name,
            goodsType: _this.goods.goodsType,
            goodsUserType: _this.goods.goodsUserType,
            type: 5, // 商城的商品
            goodsTerm: Number(_this.goods.type), // 全部0或者vip1
            maxBuyNum: _this.goods.limited,
            status: status,
            goodsId: _this.id,
            goodsNo: _this.goods.goodsNo,
            isCron: _this.goods.listStatus == 1 ? 0 : 1,
            imgUrl:
              _this.mainPicUrl.length === 0 ? "" : _this.mainPicUrl[0].url,
            goodsVipId: goodsInvisible == 1 ? _this.goods.goodsVipId : "",
            special: _this.goods.special,
            goodsInvisible: goodsInvisible,
            promptList: _this.promptList,
            payTime: _this.goods.payTime,
            vipTimeCn: _this.goods.vipTimeCn,
            vipTimeTw: _this.goods.vipTimeTw,
            vipTimeEn: _this.goods.vipTimeEn,
            vipTime: _this.goods.vipTime
              ? _this.$dayjs(_this.goods.vipTime).format("YYYY-MM-DD HH:mm:ss")
              : "",
            listStatus: _this.goods.listStatus,
            refund: _this.goods.refund,
            exchange: _this.goods.exchange,
            startTime: _this.goods.shelfTime
              ? _this
                  .$dayjs(_this.goods.shelfTime)
                  .format("YYYY-MM-DD HH:mm:ss")
              : _this.$getTime(new Date()),
            listStartTime: _this.goods.listStartTime
              ? _this
                  .$dayjs(_this.goods.listStartTime)
                  .format("YYYY-MM-DD HH:mm:ss")
              : null,
            goodsGardenia: _this.goods.goodsGardenia ? 0 : 1,
            goodsAttachList: _this.goodsService
              .concat(buyContentParam)
              .concat(imgList)
              .concat(contentParam),
            shipFee: _this.goods.freight,
            freightId: _this.goods.freight == 1 ? _this.goods.freightId : null,
            receiver: _this.goods.receiver,
            freightTitle:
              _this.goods.freight == 1 ? _this.goods.freightTitle : null,
            skuType: this.skuList.length > 0 ? 1 : 0,
            skuRequest: this.skuRequest,
            writeOffActivityId: _this.goods.writeOffActivityId,
            numberMinDigit: _this.goods.numberMinDigit,
            numberMaxDigit: _this.goods.numberMaxDigit,
            skuRequestList: _this.skuList,
            draft: 1,
            mainland: _this.goods.mainland,
            orderPromptTitle: _this.goods.orderPromptTitle,
            orderPromptId: _this.goods.orderPromptId
              ? Number(_this.goods.orderPromptId)
              : "",
          },
        ];
        if (this.skuType === 1) {
          param.skuRequestList = this.skuList;
          // param.gogdsPrice = _this.skuList[0].realPrice;
        } else {
          param.skuRequest = this.skuRequest;
          // param.gogdsPrice = this.skuRequest.realPrice;
        }
      }
      //  console.log(param);
      //  return;
      // 修改
      if (_this.id != null && _this.type === "draft") {
        // param.id = _this.id;
        _this
          .$post(
            "/request/mall/updateGoodsDetails",
            param,
            _this.$GLOBAL.jsonConfig
          )
          .then((res) => {
            _this.dialogVisible = true;
            if (res.code === "00000") {
              _this.$propMessage("修改草稿成功", "success", () => {
                console.log(preview);

                _this.dialogVisible = false;
                if (preview == "yulan") {
                  _this.$router.replace(`/goodsPreview?id=${_this.id}`);
                } else {
                  _this.$router.replace(`/goodsList`);
                  // _this.$router.go(-1);
                }
              });
            } else {
              if (_this.promptList.length == 0) {
                _this.promptList.push({
                  content: "",
                  titleCn: "",
                  titleTw: "",
                  titleEn: "",
                });
              }
              _this.$propMessage(res.message, "error", function () {
                _this.dialogVisible = false;
              });
            }
          })
          .catch((err) => {
            if (_this.promptList.length == 0) {
              _this.promptList.push({
                content: "",
                titleCn: "",
                titleTw: "",
                titleEn: "",
              });
            }
            _this.$propMessage(res.message, "error", function () {
              _this.dialogVisible = false;
            });
          });
      } else {
        // 新增
        _this
          .$post("/request/mall/saveGoods", param, _this.$GLOBAL.jsonConfig)
          .then((res) => {
            _this.dialogVisible = true;
            if (res.code === "00000") {
              _this.$propMessage("新增草稿成功", "success", () => {
                _this.dialogVisible = false;
                if (preview == "yulan") {
                  _this.$router.replace(`/goodsPreview?id=${res.data}`);
                } else {
                  _this.$router.replace(`/goodsList`);
                }
              });
            } else {
              if (_this.promptList.length == 0) {
                _this.promptList.push({
                  content: "",
                  titleCn: "",
                  titleTw: "",
                  titleEn: "",
                });
              }
              _this.$propMessage(res.message, "error", function () {
                _this.dialogVisible = false;
              });
            }
          })
          .catch((err) => {
            if (_this.promptList.length == 0) {
              _this.promptList.push({
                content: "",
                titleCn: "",
                titleTw: "",
                titleEn: "",
              });
            }
            _this.$propMessage(err.error, "error", function () {
              _this.dialogVisible = false;
            });
          });
      }
    },
    validateMinDigit() {
      this.goods.numberMinDigit = this.goods.numberMinDigit.replace(/\D/g, "");
      // 处理输入值小于0的情况，自动修正为0
      if (
        this.goods.numberMinDigit &&
        parseInt(this.goods.numberMinDigit) < 0
      ) {
        this.goods.numberMinDigit = "0";
      }
      if (
        this.goods.numberMaxDigit &&
        parseInt(this.goods.numberMaxDigit) > 999999
      ) {
        this.goods.numberMaxDigit = "999999";
      }
    },
    validateMaxDigit() {
      // 只允许输入数字，非数字字符会被移除
      this.goods.numberMaxDigit = this.goods.numberMaxDigit.replace(/\D/g, "");
      if (
        this.goods.numberMinDigit &&
        parseInt(this.goods.numberMinDigit) < 0
      ) {
        this.goods.numberMinDigit = "0";
      }
      // 处理输入值大于999999的情况，自动修正为999999
      if (
        this.goods.numberMaxDigit &&
        parseInt(this.goods.numberMaxDigit) > 999999
      ) {
        this.goods.numberMaxDigit = "999999";
      }
    },
    cancelYunfei() {
      this.yunfeiModal = false;
      this.templateTitle = "";
      this.yunfeiUrl = "";
      this.$refs.excelUploads.clearFiles();
    },
    cancelWenan() {
      this.wenanModal = false;
      this.wenanId = "";
      this.tipList = [
        {
          tipCn: "",
          tipTw: "",
          tipEn: "",
        },
      ];
    },
    yunfeiupdate() {
      let _this = this;
      if (!_this.templateTitle) {
        _this.$errorMessage("請填寫模板名稱");
        return;
      }
      if (!_this.yunfeiUrl) {
        _this.$errorMessage("請上傳運費模板");
        return;
      }
      _this.dialogVisible = true;
      _this
        .$post(
          "/request/freight/upload/v2",
          {
            templateTitle: _this.templateTitle,
            templateUrl: _this.yunfeiUrl,
          },
          _this.$GLOBAL.jsonConfig
        )
        .then((res) => {
          if (res.code == "00000") {
            _this.$propMessage("新增成功", "success", function () {
              _this.dialogVisible = false;
              _this.yunfeiModal = false;
              _this.templateTitle = "";
              _this.yunfeiUrl = "";
              _this.$refs.excelUploads.clearFiles();
              _this.getYunfei();
            });
          } else {
            _this.$propMessage(res.message, "error", function () {
              _this.dialogVisible = false;
            });
            _this.$refs.excelUploads.clearFiles();
          }
        });
    },
    wenanupdate() {
      let _this = this;
      if (!_this.wenanTitle) {
        _this.$errorMessage("請填寫模板名稱");
        return;
      }
      console.log(_this.tipList);
      _this.dialogVisible = true;
      _this
        .$post(
          "/request/order/prompt/template",
          {
            id: _this.wenanId ? _this.wenanId : null,
            title: _this.wenanTitle,
            tipList: _this.tipList,
          },
          _this.$GLOBAL.jsonConfig
        )
        .then((res) => {
          if (res.code == "00000") {
            _this.$propMessage(
              _this.wenanId ? "编辑成功" : "新增成功",
              "success",
              function () {
                _this.dialogVisible = false;
                _this.wenanModal = false;
                _this.wenanTitle = "";
                _this.wenanId = "";
                _this.tipList = [
                  {
                    tipCn: "",
                    tipTw: "",
                    tipEn: "",
                  },
                ];
                _this.getWenan();
              }
            );
          } else {
            _this.$propMessage(res.message, "error", function () {
              _this.dialogVisible = false;
            });
          }
        });
    },
    handleFileChange(file, fileList) {
      // 如果当前文件列表中有多个文件（理论上 limit=1 不会出现，但以防万一）
      if (fileList.length > 1) {
        // 移除第一个文件（旧文件），保留最新的
        this.$refs.excelUploads.handleRemove(fileList[0]);
      }
    },
  },
  components: {
    NavBar,
    Editor,
    DiaMess,
  },
};
</script>

<style lang="less" scoped>
.goods {
  .goodsWrap {
    display: flex;
    margin-bottom: 0.1rem;

    .goodsItem {
      input {
        width: 2rem;
      }
    }

    .delBtn {
      display: inline-block;
      margin: 0 0.1rem 0 0.24rem;
      cursor: pointer;
      line-height: 40px;
      color: rgba(108, 61, 234, 1);
    }
  }

  .addDetail {
    width: 0.8rem;
    height: 0.36rem;
    line-height: 0.36rem;
    text-align: center;
    background: rgba(242, 240, 247, 1);
    color: rgba(147, 142, 164, 1);
    border-radius: 0.04rem;
    cursor: pointer;
  }

  .specification {
    .specificationItem {
      margin-bottom: 0.1rem;
      font-size: 12px;
      color: #666;

      .el-input {
        width: 70%;
        padding: 0 0.1rem;
      }
    }
  }

  .bottomBtn {
    max-width: 9.6rem;
    padding-left: 0.4rem;
  }
}
.lglabel {
  height: 38px;
  line-height: 38px;
  text-align: center;
  padding: 0 20px;
  border: 1px solid #dcdfe6;
  cursor: pointer;
}
.lbnone {
  border-left-width: 0px;
  border-right-width: 0px;
}

/deep/.el-textarea__inner {
  line-height: 14px !important;
  width: 260px;
  height: 150px;
}
.dialog {
  display: flex;
  justify-content: center;
  .el-upload__tip {
    color: #65676b;
  }
}
.btngroup {
  margin-top: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn {
  text-align: center;
}
.order_title {
  font-size: 14px;
  color: #000;
}
.add_de {
  margin-left: 10px;
  font-size: 14px;
  cursor: pointer;
}
.add_de_sure {
  width: 90px;
  height: 34px;
  background: #fafafd;
  border-radius: 4px;
  border: 1px solid #ababab;
  cursor: pointer;
  margin-right: 10px;
  color: #603d8e;
}
.common_flex {
  display: flex;
  align-items: center;
}
/deep/ .el-dialog {
  border-radius: 12px;
}
/deep/ .el-dialog__header {
  // box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
}
/deep/ .el-dialog__title {
  font-size: 0.16rem;
}
/deep/ .el-upload__text em {
  color: #6c3dea !important;
}
/deep/ .el-upload-dragger:hover {
  border-color: #6c3dea !important;
}
/deep/ .el-upload-dragger {
  width: 320px !important;
  border: 1px dashed #d9d9d9 !important;
}
.yunfeiBox {
  width: 110px;
  height: 36px;
  background: #5938e0;
  border-radius: 4px;
  text-align: center;
  line-height: 36px;
  display: inline-block;
  color: #ffffff;
  cursor: pointer;
  margin-left: 10px;
}
/deep/ .el-table__empty-block {
  min-height: 400px !important;
}
.fenyeBox {
  cursor: pointer;
  margin-right: 10px;
  margin-top: 10px;
}
.skuTables {
  width: 100%;
  border-color: rgba(211, 209, 219, 0.5);
  margin-top: 20px;
  tr {
    height: 63px;
    min-height: 63px;
    td {
      text-align: center;
      color: #9792a7;
      font-size: 14px;
      padding: 10px;
      font-weight: 400;
    }
  }
  th {
    background: #f0f0f4;
    color: #909399;
    font-weight: 500;
    font-size: 14px;
  }
}
/deep/ .el-icon-close {
  font-size: 24px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/goods.vue